module.exports = __webpack_public_path__ + "img/reservation_gift3.02722b8e.png";